import { render, staticRenderFns } from "./SystemForm.vue?vue&type=template&id=35cbabb8&"
import script from "./SystemForm.js?vue&type=script&lang=js&"
export * from "./SystemForm.js?vue&type=script&lang=js&"
import style0 from "./SystemForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSelect,VTextField})
